<script setup lang="ts">
/**
 * 根组件 App.vue
 *
 * 仅承载 router-view，具体布局由路由配置中的布局组件决定
 * 全局错误边界可在此扩展
 */

import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

// 应用初始化：确保暗色主题 class 已应用
onMounted(() => {
  document.documentElement.classList.add('dark');

  // 如果存在 Token 但用户信息为空，尝试恢复用户状态
  if (authStore.token && !authStore.user) {
    authStore.fetchUserInfo().catch(() => {
      // Token 无效时静默处理，路由守卫会引导到登录页
    });
  }
});
</script>

<template>
  <router-view />
</template>
